export default __webpack_public_path__ + "static/media/referAFriendDesktop.c263c201.png";